import * as TYPES from './types';
import { sortAgentSocialNetworks, formatReviews } from '@/common/agents';

export default {
    [TYPES.SET_TESTIMONIALS](payload) {
        this.testimonials = formatReviews(payload) || [];
    },
    [TYPES.SET_AGENT](payload) {
        payload.socialNetworks = sortAgentSocialNetworks(
            payload.socialNetworks
        );
        this.agent = payload;
    },
    [TYPES.SET_AGENT_ID](payload) {
        this.agentid = payload;
    },
    [TYPES.SET_DISPLAY_MORELINK](payload) {
        this.displayMoreLink = payload;
    },
};
